module.exports = __webpack_public_path__ + "img/recovery.a03e7670.svg";